// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ResponsiveContainer-module-responsiveContainer-3sAVk{position:relative;width:100%;margin:auto}@media(min-width: 768px){.ResponsiveContainer-module-responsiveContainer-3sAVk{padding:0;margin-block:0;margin-inline:auto;max-width:1260px}}.ResponsiveContainer-module-fullWidth-1kO6d{padding:0;max-width:none;max-width:initial;margin:0;margin:initial}.ResponsiveContainer-module-small-4w5Gy{max-width:620px}.ResponsiveContainer-module-medium-h9O6W{max-width:940px}.ResponsiveContainer-module-large-GKO36{max-width:1260px}", ""]);
// Exports
exports.locals = {
	"responsiveContainer": "ResponsiveContainer-module-responsiveContainer-3sAVk",
	"fullWidth": "ResponsiveContainer-module-fullWidth-1kO6d",
	"small": "ResponsiveContainer-module-small-4w5Gy",
	"medium": "ResponsiveContainer-module-medium-h9O6W",
	"large": "ResponsiveContainer-module-large-GKO36"
};
module.exports = exports;
